export class EbayInventoryLocation
{
    Location : InventoryLocation = new InventoryLocation();   
    Name : string = "Lister-Warehouse";
    MerchantLocationStatus : string = "ENABLED";
    LocationTypes :string[]= ["WAREHOUSE"];
}

export class InventoryLocation
{
    Address : InventoryAddress = new InventoryAddress();
}

export class InventoryAddress
{
    City : string = "Fountain Valley";
    StateOrProvince : string = "CA";
    Country : string = "US";
    postalCode: string = "92708";
}
